<template>
  <div class="banner">
    <Carousel autoplay v-bind="$attrs">    
      <a
        v-for="item in bannerList"
        :key="item.ID"
        class="banner-box"
        :href="`/detail/${item.ID}`"
      >
        <img
          class="is_show_block"
          :src="item.meta_attached_file"
          alt=""
        />
        <img
          class="is_hide_block"
          :src="item.wpcf_mobile_banner_image"
          alt=""
        />
        <!-- <div class="title-box">
          <p class="img-title">{{ item.wpcf_main_visual_title }}</p>
        </div> -->
        <div class="desc">
          <p class="img-title">{{ item.wpcf_main_visual_title }}</p>
          <p class="img-desc">{{ item.wpcf_main_visual_sub_title }}</p>
          <p class="img-date" v-if="item.post_date">{{ item.post_date }}</p>         
        </div>
      </a>
    </Carousel>
  </div>
</template>
<script>
import Carousel from "ant-design-vue/lib/carousel";
import Mixin from "@/util/mixin";
export default {
  mixins: [Mixin],
  components: {
    Carousel,
  },
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  cursor: pointer;
  .banner-box {
    position: relative;
    width: 100%;
    max-height: 1000px;
    img {
      width: 100%;
      height: 100%;
    }
    .desc {
      position: absolute;
      width: 100%;      
      padding: 100vh 10% 5%;
      text-align: center;
      bottom: 0;   
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, .3));     
    }
   
    .img-title {               
      white-space:wrap;
      width: 100%;
      text-align: center;
             
      font-family: Helvetica;
      margin-bottom: 40px;
      font-size: clamp(48px, 2vw, 52px);
      font-weight: 700;
      line-height: 67px;
      color: #ffffff;
      margin-bottom: 16px;
    }
    .img-desc {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      font-family: PingFang SC;
      font-size: 16px;
      line-height: 24px;
      text-transform: uppercase;
      color: #ffffff;
      overflow: hidden;
      
    }
    .img-date {
      margin-top: 24px;
      text-align: center;
      font-family: Helvetica;
      font-style: italic;
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      color: #fbdb6b;
    }
  }
}
::v-deep.ant-carousel .slick-dots {
  bottom: 40px;
}
@media screen and (min-width: 1024px) and (max-width: 1250px) {
  .banner {
    .banner-box{
      .img-title {   
        font-size: clamp(35px, 2vw, 40px);
        line-height: 47px;
      }
    }
  }
}

@media screen and (min-width: 750px)  and (max-width: 1024px) {
  .banner {
    height: 600px;
    .banner-box {          
      height: 100%;
     
      img {
        width: 100%;
        height: 600px;
        object-fit: cover;
      }
      .desc {
        // position: absolute;
        // width: 700px;
        // left: 50%;
        // margin-left: -350px;
        // text-align: center;
        // bottom: 13%;      
        padding: 100vh 10% 8%;
        .img-title {               
          white-space:wrap;     
          width: 100%;                
          text-align: center;         
          font-family: Helvetica;          
          font-size: clamp(28px, 2vw, 38px);
          line-height: 37px;
          color: #ffffff;
          margin-bottom: 10px!important;
        }
        .img-desc{
          width: 60%;         
          font-size: 6 * $px;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .banner {
    margin-top: 76 * $px;
    .banner-box {
      position: relative;
      width: 100%;
      max-height: 650 * $px;
      z-index: 999;
    
      img {
        width: 100%;
        height: 650 * $px;
      }
      .desc {
        // position: absolute;
        // width: 80vw;
        // left: 50%;
        // margin-left: -40vw;
        // text-align: center;
        // bottom: 10%;
        padding: 100% 10% 13%;
        .img-title {              
          text-align: center;               
          width: 100%;                  
          font-family: Helvetica;
          font-style: normal;
          font-weight: 700;
          font-size: 20 * $px;
          line-height: 26 * $px;
          color: #ffffff;
          // min-height: 96 * $px;
          overflow: hidden;
        }
        .img-desc {         
          width: 100%;
          margin: 0 ;
          text-align: center;
          font-family: PingFang SC;
          font-size: 12px;
          line-height: 18 * $px;
          text-transform: uppercase;
          color: #ffffff;
          // max-height: 72*$px;
          overflow: hidden;
        }
      }
      .img-date {
        // margin-top: 46 * $px;
        margin-top:  10 * $px;
        text-align: center;
        font-family: Helvetica;
        font-style: italic;
        font-weight: bold;
        font-size: 14 * $px;
        line-height: 16 * $px;
        color: #fbdb6b;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// banner.vue